import { config } from '@iheartjane/config';
import { trackError } from '@iheartjane/tracking';

const loadSquareCard = async (locationId: string) => {
  if (!window.Square) {
    trackError(new Error('Square Web Payments SDK failed to load properly'));
  }

  const payments = window.Square?.payments(
    config.squareApplicationId,
    locationId
  );

  const card = await payments?.card();
  return card;
};

export { loadSquareCard };
